module.exports = __webpack_public_path__ + "static/humanitarian_obj@2x-1883d0acdd0186ac74711f9e00de24f1.png";